import { API_endpoints } from "../config"; 

export const updatePassword = async ( password: string, token: string): Promise<any> => {
    try {
        const response = await fetch(API_endpoints.updatePassword, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ password, token }),
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Fehler bei der Atualisierung von Password:", error);
        throw new Error("Fehler bei der Atualisierung von Password.");
    }
};
